import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import Page from '../../components/Page';

import useLocales from '../../hooks/useLocales';
import ObjectDetail from '../../components/custom-one-use/CultureObjects/ObjectDetail';
import Breadcrumb from '../../components/custom/Breadcrumb/Breadcrumb';
import SimilarObjects from '../../components/custom-one-use/CultureObjects/SimilarObjects';
import { dispatch, useSelector } from '../../redux/store';
import {
  getCOAdjacent,
  getVideoAdjacent,
  getEDUAdjacent,
  getCSAdjacent,
  getCOByKey,
  getSimilarObject,
} from '../../redux/slices/culturalObject';
import Loading from '../../components/custom/Loading/Loading';
import CustomSlovakianaHelmet from '../../components/custom/CustomSlovakianaHelmet';

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(8),
  [theme.breakpoints.up('lg')]: {
    paddingTop: theme.spacing(14),
  },
}));

export default function CultureObjectDetail() {
  const { translate, currentLang } = useLocales();
  const { id, originSimilarName } = useParams();
  const { currentCO, similarObjects, prev, next, nextIndex, prevIndex, isLoading } = useSelector(
    (state) => state.culturalObject
  );
  const [params] = useSearchParams();
  const url = decodeURIComponent(params.get('url'));
  const fromPage = params.get('fromPage');

  let path = window.location.pathname.substring(0, window.location.pathname.indexOf('/', 1));
  const pathCatalogue = window.location.pathname.includes('en/') ? `/en${translate('urls.co')}` : translate('urls.co');

  const pathVideo = window.location.pathname.includes('en/')
    ? `/en${translate('urls.video')}`
    : translate('urls.video');

  if (window.location.pathname.startsWith('/en')) {
    const firstIndex = window.location.pathname.indexOf('/');
    const secondIndex = window.location.pathname.indexOf('/', firstIndex + 1);
    const thirdIndex = window.location.pathname.indexOf('/', secondIndex + 1);

    if (thirdIndex !== -1) {
      path = window.location.pathname.substring(0, thirdIndex);
    }
  }

  // let path = window.location.pathname.substring(0, window.location.pathname.indexOf('/', 1));
  if (fromPage === 'video')
    path = window.location.pathname.includes('en/') ? `/en${translate('urls.video')}` : translate('urls.video');

  if (fromPage === 'edu')
    path = window.location.pathname.includes('en/') ? `/en${translate('urls.edu')}` : translate('urls.edu');

  const onlyWithImage = JSON.parse(decodeURIComponent(params.get('url')))?.filter
    ? JSON.parse(JSON.parse(decodeURIComponent(params.get('url'))).filter).onlyWithImage
    : true;

  const onlyDownloadable = JSON.parse(decodeURIComponent(params.get('url')))?.filter
    ? JSON.parse(JSON.parse(decodeURIComponent(params.get('url'))).filter).onlyDownloadable
    : false;

  const onlyUnBlackened = JSON.parse(decodeURIComponent(params.get('url')))?.filter
    ? JSON.parse(JSON.parse(decodeURIComponent(params.get('url'))).filter).onlyUnBlackened
    : true;

  const searchSimilarNames = JSON.parse(decodeURIComponent(params.get('url')))?.searchSimilarNames
    ? JSON.parse(decodeURIComponent(params.get('url')))?.searchSimilarNames
    : false;

  const urlre = JSON.parse(decodeURIComponent(params.get('url')));
  useEffect(() => {
    dispatch(getCOByKey(id));
    const query = JSON.parse(url || 'null');
    const searchText = (query?.search || '').replaceAll('-', ' ');
    const sort = (query?.sort || '').replaceAll('-', ' ');
    const sortDirection = (query?.sortDirection || '').replaceAll('-', ' ');
    const filter = JSON.parse(query?.filter || '{"category":[]}');
    if (path !== '/scitacie-harky' && currentCO.name !== '') {
      // dispatch(getSimilarObject(id, onlyWithImage, { locale: currentLang.getValue }));
      // missing translations in enGB

      dispatch(getSimilarObject(id, onlyWithImage, { locale: 'skSK' }));
    }

    // const abortCtrl = new AbortController();
    if (fromPage === 'cs') {
      let cats = {};
      if (filter.categoryKeys) {
        cats = filter.categoryKeys.filter((item) => item.length > 3);
        if (cats.length === 0) {
          cats = filter.categoryKeys.filter((item) => item.length === 3);
        } else {
          cats = filter.categoryKeys.filter((item) => item.length > 3);
        }
      }

      dispatch(
        getCSAdjacent({
          index: query?.index,
          searchText,
          sortAttribute: sort,
          sortDirection,
          searchByKeywords: true,
          categoryKeys: cats,
          tagKeys: filter.tagKeys,
          onlyUnBlackened,
          //  signal: abortCtrl.signal,
        })
      );
    } else if (fromPage === 'video') {
      dispatch(
        getVideoAdjacent({
          index: query?.index,
          searchText: query?.searchText || query.search,
          searchByKeywords: query?.searchByKeywords || true,
          sortAttribute: sort,
          sortDirection,
          categoryKeys: query?.categoryKeys,
          tagKeys: query?.tagKeys,
          // signal: abortCtrl.signal,
        })
      );
    } else if (fromPage === 'edu') {
      dispatch(
        getEDUAdjacent({
          index: query?.index,
          searchText: query?.searchText,
          searchByKeywords: query?.searchByKeywords || true,
          sortDirection: sortDirection || 1,
          sortAttribute: sort || 'created',
          categoryKeys: query?.categoryKeys,
          tagKeys: query?.tagKeys,
          // signal: abortCtrl.signal,
        })
      );
    } else {
      dispatch(
        getCOAdjacent({
          index: query?.index,
          searchText: searchSimilarNames ? decodeURIComponent(originSimilarName) : query?.searchText || query?.search,
          searchByKeywords: query?.searchByKeywords || true,
          // eslint-disable-next-line no-nested-ternary
          sortAttribute: sort !== '' ? sort : searchSimilarNames ? 'rank' : 'dateModified',
          searchSimilarNames: searchSimilarNames || false,
          sortDirection: sortDirection || 1,
          categoryKeys: filter.categoryKeys,
          tagKeys: filter.tagKeys,
          onlyWithImage: filter?.onlyWithImage !== undefined ? filter?.onlyWithImage : true,
          onlyDownloadable: filter?.onlyDownloadable !== undefined ? filter?.onlyDownloadable : false,
          originDateFrom: filter?.originDateFrom ? new Date(query?.originDateFrom) : undefined,
          originDateTo: filter?.originDateTo ? new Date(filter?.originDateTo) : undefined,
          // signal: abortCtrl.signal,
        })
      );
    }
  }, [
    id,
    url,
    path,
    fromPage,
    currentLang.getValue,
    onlyWithImage,
    searchSimilarNames,
    onlyUnBlackened,
    currentCO.name,
    onlyDownloadable,
    originSimilarName,
  ]);

  const meta = {
    description: currentCO?.pfiName || '',
    keywords: currentCO?.pfiName?.split(', ') || [],
    social: {
      ogTitle: `Slovakiana | ${currentCO?.name}`,
      ogDescription: currentCO?.pfiName || '',
      ogObjects: [
        {
          ogType: 'image',
          ogImageUrl:
            currentCO?.thumbnail !== undefined && currentCO.thumbnail !== ''
              ? `${process.env.REACT_APP_API_URL}/image/download/${currentCO?.thumbnail}?sizeIndex=0`
              : '',
          ogImageSecureUrl:
            currentCO?.thumbnail !== undefined && currentCO.thumbnail !== ''
              ? `${process.env.REACT_APP_API_URL}/image/download/${currentCO?.thumbnail}?sizeIndex=0`
              : '',
          ogImageAlt: currentCO?.name || '',
        },
      ],
    },
  };
  return (
    <Page>
      <CustomSlovakianaHelmet
        title={`Slovakiana | ${translate('default.cultureObjectDetail')} - ${currentCO?.name}`}
        meta={meta}
      />
      <RootStyle>
        <Breadcrumb
          loading={isLoading}
          path={path}
          prevKey={originSimilarName && prev ? `${prev}/${originSimilarName}` : prev}
          nextKey={originSimilarName && next ? `${next}/${originSimilarName}` : next}
          prevIndex={prevIndex}
          nextIndex={nextIndex}
          urlParams={url}
        />
        {currentCO.key && (
          <Grid sx={{ position: 'relative' }}>
            {isLoading && <Loading />}
            <ObjectDetail detail={currentCO} />
            {!currentCO?.isCensusSheet && (
              <SimilarObjects
                title="objects.similaryObjects"
                redirect={fromPage === 'video' ? pathVideo : pathCatalogue}
                items={similarObjects.results}
                search={currentCO?.name}
                onlyWithImage={onlyWithImage}
                onlyDownloadable={onlyDownloadable}
                searchSimilarNames
                urlfilter={urlre}
                currentCoName={currentCO?.name}
              />
            )}
          </Grid>
        )}
      </RootStyle>
    </Page>
  );
}
